import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {

        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {

    },

    mutations: {
        save(state, action) {

            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
        queryaccountpage(context, payload) {
            return D.select({
                ...payload
            })
        },

        queryaccount(context, payload) {
            return D.select({
                ...payload
            })
        },

        addaccount(context, payload) {
            return D.add({
                ...payload
            })
        },

        destroyaccount(context, payload) {
            return D.select({
                ...payload
            })
        },

        updateaccount(context, payload) {
            return D.edit({
                ...payload
            })
        },

        relatesys(context, payload) {
            return D.edit({
                ...payload
            })
        },

        syncjenkins(context, payload) {
            return D.select({
                ...payload
            })
        },

        queryrelatesys(context, payload) {
            return D.select({
                ...payload
            })
        },

        disableRelation(context, payload) {
            return D.edit({
                ...payload
            })
        },

        updateRelation(context, payload) {
            return D.edit({
                ...payload
            })
        },

        queryTask(context, payload) {
            return D.select({
                ...payload
            })
        },
        updaterelatesys(context, payload) {
            return D.edit({
                ...payload
            })
        },
        
        queryRelatedSys(context, payload) {
            return D.select({
                ...payload
            })
        },

        addrelateSys(context, payload) {
            return D.add({
                ...payload
            })
        },
        
        detailrelatesys(context, payload) {
            return D.select({
                ...payload
            })
        },

        queryJenkins(context, payload) {
            return D.select({
                ...payload
            })
        },
        addJenkins(context, payload) {
            return D.add({
                ...payload
            })
        },
        pageJenkins(context, payload) {
            return D.select({
                ...payload
            })
        },
        delJenkins(context, payload) {
            return D.del({
                ...payload
            })
        },
        updateJenkins(context, payload) {
            return D.edit({
                ...payload
            })
        },
        queryres(context, payload) {
            return D.select({
                ...payload
            })
        },
        addres(context, payload) {
            return D.add({
                ...payload
            })
        },
        updateres(context, payload) {
            return D.edit({
                ...payload
            })
        },
        addDomain(context, payload) {
            return D.add({
                ...payload
            })
        },
        queryDomain(context, payload) {
            return D.select({
                ...payload
            })
        },
        pageDomain(context, payload) {
            return D.select({
                ...payload
            })
        },
        dispatchDomain(context, payload) {
            return D.edit({
                ...payload
            })
        },
        destroyDomain(context, payload) {
            return D.del({
                ...payload
            })
        },

        listMiddleware(context, payload) {
            return D.select({
                ...payload
            })
        },

        addMiddleware(context, payload) {
            return D.add({
                ...payload
            })
        },

        delMiddleware(context, payload) {
            return D.del({
                ...payload
            })
        },

        queryMiddleware(context, payload) {
            return D.select({
                ...payload
            })
        },

        updateMiddleware(context, payload) {
            return D.edit({
                ...payload
            })
        },

        queryDefaultConfig(context, payload) {
            return D.select({
                ...payload
            })
        },

        buildJob(context, payload) {
            return D.select({
                ...payload
            })
        },

        queryJobStatus(context, payload) {
            return D.select({
                ...payload
            })
        },

        queryJobUrl(context, payload) {
            return D.select({
                ...payload
            })
        },

        syncJenkinsOne(context, payload) {
            return D.edit({
                ...payload
            })
        },

    }
}
